module.exports = __webpack_public_path__ + "img/pic_empty_resources@2xs.d2d390ce.png";